import {Component} from "@angular/core";
import {PreparationModifierSearchModel} from "../preparation-modifier-search-model.service";
import {PreparationModifierEntityModel} from "../preparation-modifier-entity-model.service";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-preparation-modifier-search-page",
    templateUrl: "./preparation-modifier-search-page.component.html",
    providers: [provideSearchModel(PreparationModifierSearchModel), provideEntityModel(PreparationModifierEntityModel)]
})
export class PreparationModifierSearchPageComponent extends AbstractSearchPage {
    showTypeFilter: boolean = true;

    constructor(private searchModel: PreparationModifierSearchModel) {
        super();
    }

    prepareInitialFilter(): void {
        if (this.isSelectMode()) {
            if (this.extendedSearchParams.searchParams) {
                this.searchModel.filter["type"] = this.extendedSearchParams.searchParams["type"];
            }
            this.showTypeFilter = false;
        }
    }
}
